import type { NetMessage } from './transport';
import type { HubMapId } from '../data/hub-map.config';
import { PresenceView, isHubRoster, type PresenceState } from './hubPresence';

/**
 * Client side of hub presence. Holds the latest host roster and the host's
 * current map id; smoothing/pruning is delegated to PresenceView (driven by the
 * presence hook each tick).
 */
export class HubPresenceClient {
  public roster: PresenceState[] = [];
  public hostMapId: HubMapId | null = null;
  public readonly view = new PresenceView();
  private lastCount = 0;

  constructor(private onPlayerCount?: (count: number) => void) {}

  handle(m: NetMessage): void {
    if (!isHubRoster(m)) {
      return;
    }
    const countChanged = m.count !== this.lastCount;
    this.lastCount = m.count;
    this.roster = m.roster;
    this.hostMapId = m.hostMapId;
    if (countChanged) {
      this.onPlayerCount?.(m.count);
    }
  }
}
